module.exports = __webpack_public_path__ + "static/img/HTFJJ_H5.125126b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HTFJJ_H5.png
// module id = 9QME
// module chunks = 34